module.exports = __webpack_public_path__ + "media/images/camp_map-8c959892c4b7322805d34f0354e5c938.png";